"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _appActionMenu = _interopRequireDefault(require("../../app-action-menu/app-action-menu"));

var _myAccountMenuItems = _interopRequireDefault(require("../my-account-menu-items.shape"));

const MyAccountMenu = props => {
  const {
    onSelect,
    storeName,
    storeUrl,
    className,
    menuTypes
  } = props;

  const onMenuSelect = ({
    value
  }) => {
    onSelect(value);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('my-account-menu', className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "my-account-menu__store-details"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "my-account-menu__store-details-inner"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "my-account-menu__store-icon"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "my-account-menu__store-info"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "my-account-menu__store-name"
  }, storeName), /*#__PURE__*/_react.default.createElement("span", {
    className: "my-account-menu__store-url"
  }, storeUrl)))), /*#__PURE__*/_react.default.createElement(_appActionMenu.default, {
    items: menuTypes,
    onSelect: onMenuSelect,
    className: "my-account-menu__menu"
  }));
};

MyAccountMenu.propTypes = {
  storeName: _propTypes.default.string.isRequired,
  storeUrl: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  onSelect: _propTypes.default.func.isRequired,
  menuTypes: _myAccountMenuItems.default.isRequired
};
MyAccountMenu.defaultProps = {
  className: ''
};
var _default = MyAccountMenu;
exports.default = _default;